import React from "react"
import {Helmet} from "react-helmet"
import _ from "lodash"
import Config from "../../config";

console.log(Config.environment)

function HtmlHeader({title, imageUrl}) {
  let imgMeta = null
  if(!_.isNil(imageUrl)) {
    imgMeta = <meta id="og-image" property="og:image" content={imageUrl} />
  }

  // we do not want google to index staging pages
  let noindex = null;
  if(Config.environment !== "production") {
    // https://developers.google.com/search/reference/robots_meta_tag?hl=de
    noindex = <meta name="robots" content="noindex,nofollow" /> 
  }

  return (
    <Helmet>
      <title>{title}</title>
      {noindex}
      <meta id="meta-description" name="description" content={title} />
      <meta id="og-title" property="og:title" content={title} />
      {imgMeta}
    </Helmet>
  )
}

export default HtmlHeader